export default "__VITE_ASSET__O$2XKPuC__"